( function( $ ) {
	/*
        Description: For all occurances of the parallax hero, loop through the content and check if any text has been input.
        If there is text, add the 'hide--image--mobile' class.
        Otherwise, do nothing and show the image on mobile.
    */

	// Loop through all occurances of the Parallax hero content component inner wrapper.
	$( '.parallax-hero__content-wrapper' ).each( function() {
		var shouldHideImages = false; // By default, we should not hide the image on mobile.

		// Loop through any elements that may contain text within the wrapper. This may need to be amended if the block gets modified.
		$( this ).find( '.section__heading span, .section__paragraph' ).each( function() {
			if ( $( this ).text() != '' ) {
				shouldHideImages = true; // If there is text within the block, we should hide the image on mobile.
			}
		} );

		// Hide the background image on mobile if necessary.
		if ( shouldHideImages ) {
			$( this ).parents( '.parallax-hero' ).addClass( 'hide--image--mobile' );
		}
	} );
}( jQuery ) );
